<template>
    <section class="page4">
        <div class="conteudo text-left">
            <div class="col1">
                <p
                    class="openSans text-big text-red text-bold"
                    data-aos="fade-right"
                    data-aos-delay="200"
                >
                    Por que adequar políticas e processos à LGPD?
                </p>
                <p class="p2" data-aos="fade" data-aos-delay="400">
                    O seu RH precisa estar preparado para as novas exigências
                    legais, a fim de garantir o sigilo dos dados e evitar
                    penalidades.
                </p>
                <p
                    class="openSans text-big text-red text-bold p4"
                    data-aos="fade-right"
                    data-aos-delay="800"
                >
                    Quem deve ser responsável pelas informações?
                </p>
                <p class="p2" data-aos="fade" data-aos-delay="1000">
                    Todos os colaboradores da empresa, sem exceção, são
                    responsáveis por um vazamento ou uma violação de dados.
                    Desse modo, tão importante quanto estar em
                    <i>compliance</i> com as normas de proteção de dados
                    pessoais, é exigir o mesmo dos parceiros e fornecedores do
                    seu RH.
                </p>
                <p class="p2" data-aos="fade" data-aos-delay="1100">
                    Assim, para que você caminhe em direção a
                    essa regularização, é preciso ter entendimento sobre os
                    seguintes tópicos:
                </p>
                <p class="p2 text-bold" data-aos="fade" data-aos-delay="1200">
                    · O que é a LGPD para o RH;<br />
                    · Tipos de dados;<br />
                    · 6 etapas do plano estratégico.<br />
                </p>
                <p class="p2" data-aos="fade" data-aos-delay="1200">
                    Vamos lá!
                </p>
            </div>
            <div class="col2">
                <img
                    class="img-shadow"
                    src="~@/assets/img/page3-img.png"
                    alt=""
                    data-aos="fade-up"
                />
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.page4 {
    background-image: url("~@/assets/img/page3-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: 50px;
    padding-bottom: 50px;

    @media (max-width: 1250px) {
        padding-left: 20px;
        padding-right: 20px;
        .conteudo {
            .col2 {
                img {
                    max-width: 100%;
                }
            }
        }
    }
    @media (max-width: 900px) {
        padding-left: 20px;
        padding-right: 20px;
        .conteudo {
            max-width: 100%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .col2 {
                padding-top: 30px;
            }
        }
    }
}
</style> 